<div *ngIf="data">
  <!-- sports and inplay -->
  <div class="" *ngIf="!events.races.includes(eventId)">
    
    <div class="" *ngIf="router.url.includes('sports')">
      <img class="d-block w-100" src="https://speedcdn.io/assets/radheexch-client/banner-event-id-{{eventId}}.jpg" alt="">
    </div> <!-- end col-->
    <div class="sub_path"><p>{{eName}}</p></div>
    
    
    <div class="game-wrap py-1" *ngIf="data && data.length > 0">
      <div class="row oneX2">
          <div class="col-md-7">
          </div>
          <div class="col-md-5 px-lg-0">
              <div class="h-backLay">
                  <div class="btn-group">
                      <span>1</span>
                  </div>
                  <div class="btn-group">
                      <span>X</span>
                  </div>
                  <div class="btn-group">
                      <span>2</span>
                  </div>
              </div>
          </div>
      </div>
      <!-- event match start-->
      <div class="row mx-0 align-items-center" *ngFor="let item of data;trackBy:trackByIndex;" [routerLink]="['/event/detail', item?.event_id]">
          <div class="col-md-5 px-0">
              <div class="date-eventname">
                  <!-- <span class="date">{{(item.open_date_format) ? (item.open_date_format | date : 'dd-MM-YYY hh:mm a') : item.market_start_time_format | date : 'dd-MM-YYY hh:mm a'}} | &nbsp;</span> -->
                  <a href="javascript:void(0)" >
                    <b>
                      <p class="m-0">{{(item.open_date_format) ? (item.open_date_format | date :
                        'dd MMM') : item.market_start_time_format | date : 'dd MMM'}}</p>
                      <p class="m-0">{{(item.open_date_format) ? (item.open_date_format | date :
                        'hh:mm a') : item.market_start_time_format | date : 'hh:mm a'}}</p>
                      <span class="green-round" *ngIf="item.in_play == 1"></span> 
                      <span class="teamvsname"> {{(item.name) ? item.name : item.market_name}}</span>
                    </b>
                  </a>
                  <!-- <em *ngIf="item.in_play">live now</em> -->

                  <span class="mo_tbf">
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/tv.svg" *ngIf="item.tv_channel != '' && item.tv_channel != null">
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/bm-icon1.svg" *ngIf="item.bm_active == 1">
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/fancy-icon1.svg" *ngIf="item.fancy_active == 1">
                      <i class="fa-duotone fa-square-{{item.custom_active | lowercase}}" *ngIf="item.custom_active != ''"></i>
                  </span>

                  <div class="mtitle">
                      <span>
                          <i class="mdi mdi-clock-fast"></i>
                          <span>{{(item.open_date_format) ? (item.open_date_format | date : 'dd-MM-YYY hh:mm a') : item.market_start_time_format | date : 'dd-MM-YYY hh:mm a'}}</span> | {{(item.name) ? item.name : item.market_name}}
                      </span>
                      <!-- <a href="javascritpt:void(0)" class="m_add-pin">
                          <i class="mdi mdi-pin"></i>
                      </a> -->
                  </div>
              </div>
          </div>
          <div class="col-md-2 px-0">
              <ul class="tv-bm-fancy">
                  <li>
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/tv.svg" *ngIf="item.tv_channel != '' && item.tv_channel != null">
                  </li>
                  <li>
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/bm-icon1.svg" *ngIf="item.bm_active == 1">
                  </li>
                  <li>
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/fancy-icon1.svg" *ngIf="item.fancy_active == 1">
                  </li>
                  <li class="custom" *ngIf="item.custom_active != ''">
                    <i class="fa-duotone fa-square-{{item.custom_active | lowercase}}"></i>
                  </li>
              </ul>
          </div>
          
          <!-- mobile 1x1 -->
          <div class="m-oneX2">
              <span>1</span>
              <span>x</span>
              <span>2</span>
          </div>
          <!-- mobile 1x1 -->

          <div class="col-md-5 px-0 d-flex">
              <div class="h-backLay">
                <div class="btn-group">
                    <button class="back {{odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price : '-' }}</button>
                    <button class="lay {{odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price : '-' }}</button>
                    <!-- <span class="suspended">suspended</span> -->
                </div>
                <div class="btn-group">
                    <button class="back blink-gold {{odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price : '-' }}</button>
                    <button class="lay {{odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price : '-' }}</button>
                </div>
                <div class="btn-group">
                  <button class="back {{odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price : '-' }}</button>
                  <button class="lay {{odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price : '-' }}</button>
                </div>
              </div>
              <!-- <a href="" class="add-pin">
                  <i class="mdi mdi-pin"></i>
              </a> -->
              <!-- note: add class fill-pin for multi market -->
          </div>
      </div>
      <!-- event match end-->
      <!-- view more -->
      <div class="row mx-0 align-items-center">
          <div class="col-md-12 px-0">
              <a href="javascript:void(0)" routerLink="/sports/{{eventId}}" class="viewmore">view more...</a>
          </div>
      </div>
      <!-- view more end-->
    </div>
    <div class="game-wrap py-1 norecords" *ngIf="data && data.length == 0"><a>No real-time records found</a></div>
  </div>
  <!-- races -->
  <div class="" *ngIf="events.races.includes(eventId)">
    
    <div class="" *ngIf="router.url.includes('sports')">
      <img class="d-block w-100" src="https://speedcdn.io/assets/radheexch-client/banner-event-id-{{eventId}}.jpg" alt="">
    </div> <!-- end col-->
    <div class="sub_path"><p>{{eName}}</p></div>
    
    <!-- races -->
    <div class="game-wrap" *ngIf="data && events.races.includes(eventId)">                              
      <!-- event match start-->
      <div class="row mx-0 align-items-center p-0">
          <div class="col-12 px-0 horseList" *ngFor="let item of data;trackBy:trackByIndex;">
              <h5>{{item?.event_name}}</h5>
              <ul class="hl_ul">
                  <li>
                    <a href="javascript:void(0)" class="" [routerLink]="['/event/detail', rc?.event_id, rc?.market_id]" *ngFor="let rc of item.data;trackBy:trackByIndex;">
                      {{rc?.market_start_time_format | date : 'HH:mm'}}
                    </a>
                  </li>
              </ul>
          </div>
      </div>
      <!-- event match end-->
    </div>
    <div class="game-wrap py-1 norecords" *ngIf="data && data.length == 0"><a>No real-time records found</a></div>
  </div>
</div>